<template>
  <div>
    <div
      v-for="(configurableOptionProduct, optionProductIndex) in configurableOptionProducts"
      :key="optionProductIndex"
      :id="getOptionProductConfigurationElementId(configurableOptionProduct)"
      class="option-product-configuration__list"
    >
      <h4 class="option-product-configuration__heading">{{ configurableOptionProduct.ProductRetailName }}</h4>
      <div v-if="configurableOptionProduct.LetterJacketProductCaptions !== null">
        <option-product-caption
          v-for="letterJacketProductCaption in configurableOptionProduct.LetterJacketProductCaptions"
          :key="letterJacketProductCaption.CaptionReplaceField"
          :option-product-caption="letterJacketProductCaption"
          :option-product="configurableOptionProduct"
        />
      </div>
    </div>
    <div
      v-if="someOptionProductsHaveCaptions"
      class="letter-jacket-product__caption-required-message"
    ><span class="letter-jacket-product__caption-required-symbol">*</span> required field</div>
  </div>
</template>

<script>
import OptionProductCaption from './OptionProductCaption'
import { some } from 'lodash'

export default {
  name: 'OptionProductConfigurations',
  components: {
    OptionProductCaption
  },
  computed: {
    configurableOptionProducts () {
      return this.$store.getters.getConfigurableOptionProducts
    },
    someOptionProductsHaveCaptions () {
      return this.configurableOptionProducts.length > 0 && some(this.configurableOptionProducts, (cop) => { return cop.LetterJacketProductCaptions !== null })
    }
  },
  methods: {
    getOptionProductConfigurationElementId (optionProduct) {
      return `option-product-configuration-${optionProduct.CatalogPackageOptionProductID}`
    }
  }
}
</script>

<style lang="scss" scoped>
.option-product-configuration {
  &__list {
    margin-bottom: 10px;
  }

  &__heading {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/letter-jackets/catalog-details/components/PackageOptions/OptionProduct/OptionProductConfigurations.vue